<template>
  <div class="ag-header-group-cell-label store-group-header">
    <img
      v-if="icon"
      class="store-group-header__icon"
      :src="icon"
      alt=""
      width="20"
      height="20"
    >
    <span class="store-group-header__name">{{ displayName }}</span>
  </div>
</template>

<script>
export default {
  name: 'StoreGroupHeader',
  computed: {
    icon() {
      return this.params?.icon || ''
    },
    displayName() {
      return this.params?.storeName || this.params?.displayName || ''
    }
  }
}
</script>

<style>
.store-group-header {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: 100%;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  overflow: hidden;
}

.store-group-header__icon {
  display: block;
  width: 20px;
  height: 20px;
  margin: 0;
  padding: 0;
  border: 0;
  flex: 0 0 20px;
}

.store-group-header__name {
  display: block;
  margin: 0 0 0 6px !important;
  padding: 0;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
